import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  min-width: 320px;
`;

const Title = styled.h3`
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 8px;
`;

const PlanItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid ${({ selected }) => (selected ? getColor('primary') : select('midDarkGrayAux'))};
  border-radius: 8px;
  padding: 12px 16px;
  cursor: pointer;
  transition: border 0.2s ease;
  :hover {
    background: ${({ selected }) => (selected ? getColor('tertiary') : select('neutralGray'))};
  }
`;

const RadioCircle = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid ${({ selected }) => (selected ? getColor('primary') : select('midDarkGrayAux'))};
  border-radius: 50%;
  margin-right: 12px;
  position: relative;

  &::after {
    content: '';
    display: ${({ selected }) => (selected ? 'block' : 'none')};
    width: 10px;
    height: 10px;
    background: ${getColor('primary')};
    border-radius: 50%;
    position: absolute;
    top: 3px;
    left: 3px;
  }
`;

const PlanContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: ${({ device }) => (device === 'mobile' ? 'flex-start' : 'center')};
  flex-direction: ${({ device }) => (device === 'mobile' ? 'column' : 'row')};
  flex: 1;
  gap: 12px;
`;

const PlanName = styled.span`
  font-weight: 500;
  font-size: 14px;
  width: ${({ device }) => (device === 'mobile' ? '100%' : '180px')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Tag = styled.span`
  font-size: 12px;
  padding: 4px 8px;
  margin-top: 4px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 125px;
  height: 24px;
  text-align: center;
  border: 1px solid ${({ selected }) => (selected ? getColor('primary') : select('neutralDarkGray'))};
  background: ${select('white')};
`;

const Available = styled.span`
  font-size: 12px;
  white-space: nowrap;
  > span {
    font-weight: 600;
  }
`;

export { Container, Title, PlanItem, RadioCircle, PlanContent, PlanName, Tag, Available };
